import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, List, Typography } from '@mui/material';
import { PropertyListItem } from '@atoms';
import { BoxContainer, FullWidthContent, MainMenuLayout } from '@layouts';
import { GoBackButton } from '@molecules';
import { DETAIL_ITEMS } from './constants';
import { PendingProspect } from '../data/useGetPendingProspects';

/**
 * Detail screen for a pending prospect registration
 */
const PendingProspectDetailScreen: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation() as { state: PendingProspect | null };
  const [prospect] = useState(state);

  /**
   * Navigates back to the pending prospects list
   */
  const goBack = () => {
    navigate('/prealta/gestion-pendientes');
  };

  return (
    <MainMenuLayout>
      <FullWidthContent>
        <BoxContainer>
          <Typography variant='h4' mb={3}>
            {t('PENDING_PROSPECTS:DETAIL:TITLE')}
          </Typography>
          {prospect ? (
            <List>
              {DETAIL_ITEMS.map(({ label, getText }) => {
                const value = getText(prospect);
                return (
                  <PropertyListItem
                    key={label}
                    label={label}
                    value={
                      value || (
                        <Typography
                          sx={{ fontStyle: 'italic', fontSize: 15, color: 'neutral.400' }}
                        >
                          {t('COMMON:NO_INFORMATION')}
                        </Typography>
                      )
                    }
                  />
                );
              })}
            </List>
          ) : (
            <Alert variant='filled' severity='error'>
              {t('PENDING_PROSPECTS:DETAIL:MISSING')}
            </Alert>
          )}
        </BoxContainer>
        <GoBackButton
          variant='outlined'
          text='COMMON:GO_BACK'
          onClick={() => {}}
          backFunction={goBack}
        />
      </FullWidthContent>
    </MainMenuLayout>
  );
};

export default PendingProspectDetailScreen;
